import React, { Component } from 'react'
import { connect } from 'react-redux'
import { login } from '../../actions'

import './Login.css'

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {username: '', password: ''}
  }

  _handleSubmit = (e) => {
    const { login } = this.props
    login(this.state)
    e.preventDefault()
  }

  _handleChange = (e) => {
    const target = e.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    this.setState({
      [name]: value
    })
  }

  _renderForm() {
    return (
      <form className="form form--boxed" onSubmit={this._handleSubmit} method='post'>
        <div className="form-field">
          <label className="form-field__label">Username:</label>
          <input 
            className="form-field__input" 
            type="text" 
            onChange={this._handleChange}
            name="username"
            value={this.state.username}>
          </input>
        </div>

        <div className="form-field">
          <label className="form-field__label">Password:</label>
          <input 
            className="form-field__input" 
            type="password" 
            onChange={this._handleChange}
            name="password"
            value={this.state.password}>
          </input>
        </div>

        <button className="button" type="submit">Log in</button>
      </form>
    )
  }

  render() {
    const { authentication } = this.props

    return (
      <div className="page--padded login-page hbox hbox--hcenter">

        {authentication.isAuthenticated
          ? <div>Logged in successfully</div>
          : this._renderForm()}        
      </div>
    )
  }
}

export default connect( (state) => ({authentication: (state.authentication || {})}), { login })(Login)


// WEBPACK FOOTER //
// ./src/components/Auth/Login.js